import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, EMPTY, timer } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { SharedService } from "./services/shared.service";

@Injectable({ providedIn: 'root' })
export class CustomPreloadingStrategy implements PreloadingStrategy {
  constructor(private sharedService: SharedService) {
  }
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if(!this.sharedService.isBrowser)
      return load();

    const noPreload = route.data && route.data['noPreload'];
    if (noPreload)
      return EMPTY;

    else {
      return load();
      //delay loading modules
      // return timer(5000).pipe(mergeMap(_ => {
      //   return load();
      // }));
    } 
  }
}

// export function preloadDelay(route: Route): number {
//   if (!isNaN(data)) return data;

//   // const conn = (<any>navigator).connection;// Get NetworkInformation object
//   // if (conn) {
//   //   if (conn.saveData) return undefined;// Save-Data mode
//   //   const effectiveType = conn.effectiveType || '';// 'slow-2g', '2g', '3g', or '4g'
//   //   if (effectiveType.includes('2g') || effectiveType.includes('3g')) return undefined;// 2G or 3G network
//   // }
//   return 5000;
// }
